module.exports = __webpack_public_path__ + "assets/img/background_image_login.156ff8d6.jpg";